module.exports = __webpack_public_path__ + "img/developTest.61909c7c.png";